import { api } from "./axiosClient";
import type { ContractType } from "../types/contractType.types";

export const contractTypesApi = {
  searchContractTypes: async (payload: any) => {
    const response = await api.post("/contractType/search", payload);
    return response.data;
  },

  createContractType: async (data: Partial<ContractType>) => {
    const response = await api.post("/contractType/create", data);
    return response.data;
  },

  updateContractType: async (data: Partial<ContractType>) => {
    const response = await api.post("/contractType/edit", data);
    return response.data;
  },

  removeContractType: async (id: string) => {
    return await api.post("/contractType/remove", { id });
  },

  activateContractType: async (id: string) => {
    return await api.post("/contractType/activate", { id });
  },

  deactivateContractType: async (id: string) => {
    return await api.post("/contractType/deactivate", { id });
  },
};